export default __webpack_public_path__ + "images/graphics/sell-car-white.png";